import { Component, OnInit, ViewChild } from '@angular/core';

import assert from 'tiny-invariant';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FocusableMixin } from '@ts/shared/form/focus/util-core';
import { AutofocusIonicFieldInputProps } from '@ts/shared/form/focus/util-ionic';
import { InputFieldComponent } from '@ts/shared/form/ui-formly';

import { otpValidator } from '../otp.validator';

@Component({
  selector: 'ts-otp-form-field-ui',
  templateUrl: './otp-form-field-ui.component.html',
  styleUrls: ['./otp-form-field-ui.component.scss'],
  imports: [InputFieldComponent],
})
export class OtpFormFieldUiComponent
  extends FieldType<FieldTypeConfig<AutofocusIonicFieldInputProps>>
  implements OnInit, FocusableMixin
{
  @ViewChild(InputFieldComponent) inputFieldComponent!: InputFieldComponent;

  inputFieldProps!: AutofocusIonicFieldInputProps;

  OTP_LENGTH = 6;

  setFocus() {
    this.inputFieldComponent.setFocus();
  }

  ngOnInit() {
    // TODO(irvan): These are hacks, the props are supposed to be readonly.
    assert(this.props);
    this.props['maxLength'] = this.OTP_LENGTH;
    this.props['minLength'] = this.OTP_LENGTH;

    this.formControl.addValidators(otpValidator);

    // We remove the label, because the ion-input styling will affect the label if we put the label
    // inside ion-input.
    this.inputFieldProps = { ...this.props, type: 'text', label: undefined };
  }
}
